import type { Stage } from '@/domain/creature/types';

export const WORLD_SCALE = {
  primaryTreeHeight: 200,
  stageHeight: {
    egg: 34,
    baby: 42,
    teen: 51,
    adult: 60,
    elder: 59,
  },
  collectibleHeight: 24,
} as const;

export function displayHeightForStage(stage: Stage): number {
  if (stage === 'dead') return WORLD_SCALE.stageHeight.elder;
  return WORLD_SCALE.stageHeight[stage];
}
